module.exports = __webpack_public_path__ + "img/other_pay_credit_card3.afdc7d47.svg";